<template>
  <Classes />
</template>

<script>
import Classes from '@/components/admin/Classes.vue'

export default {
  name: 'AdministrationClasses',
  components: { Classes }
}
</script>

<style scoped>

</style>
